import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { enableProdMode } from '@angular/core';
import { environment } from './environments/environment';
import { AppModule } from './app/app.module';
import * as LogRocket from 'logrocket';

if (environment.production) {
  enableProdMode();

  // Disable console logs in production
  // Disabling the disabling of logs in production so that LogRocket can capture them
  // if(window){
  //   window.console.log=function(){};
  // }
}

LogRocket.init(environment.LogRocketID);

platformBrowserDynamic().bootstrapModule(AppModule);



// WEBPACK FOOTER //
// ./src/main.ts